import { IHttpApi } from '@cian/http-api';
import { ILogger } from '@cian/logger';

import { ResponseError } from '../../errors/ResponseError';
import {
  EDealType,
  EEntityType,
} from '../../repositories/favorites/entities/add_favorite/AddFavoriteEntityPublicRequestSchema';
import { IAddFavoriteResponseSchema } from '../../repositories/favorites/entities/add_favorite/AddFavoriteResponseSchema';
import { fetchAddFavorite, TAddFavoriteResponse } from '../../repositories/favorites/v1/add-favorite';

interface IAddNewbuildingToFavoritesProps {
  httpApi: IHttpApi;
  logger: ILogger;
  newbuildingId: number;
}

export const addNewbuildingToFavorites = async ({
  httpApi,
  logger,
  newbuildingId,
}: IAddNewbuildingToFavoritesProps): Promise<IAddFavoriteResponseSchema> => {
  try {
    const response: TAddFavoriteResponse = await fetchAddFavorite({
      httpApi,
      parameters: {
        entityId: newbuildingId,
        dealType: EDealType.Sale,
        entityType: EEntityType.Newbuilding,
      },
    });

    if (response.statusCode !== 200) {
      throw new ResponseError({
        domain: 'favorites#addNewbuildingToFavorites',
        message: response.response.message as string,
        details: {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          error: response.response.errors as any,
        },
      });
    }

    return response.response;
  } catch (error) {
    logger.error(error, {
      domain: 'addNewbuildingToFavorites',
    });

    throw error;
  }
};
